import { atom } from 'recoil';

import { Atoms } from '@store/constants';

export const cachedPageUrlAtom = atom<string>({
  key: Atoms.cachedPageUrl,
  default: '',
});
